import { render, staticRenderFns } from "./step-tech.vue?vue&type=template&id=432a521f"
import script from "./step-tech.vue?vue&type=script&lang=ts"
export * from "./step-tech.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports